import createStore from './factory';

export default class SessionStore extends createStore({
  setUser(state, id, name, level) {
    const sameId = (id || 0) === (state.userId || 0);
    const sameName = (name || "") === (state.userName || "");
    const sameLevel = (level || 0) === (state.userLevel || 0);
    if (sameName && sameLevel && sameId) return state;
    state = {...state, userId: id, userName: name, userLevel: level};
    if (!sameId) {
      state.folders = null;
      state.profiles = null;
    }
    return state;
  },

  setFolders(state, folders) {
    const prev = state.folders;
    if (typeof folders === "function") folders = folders(prev);
    if (folders === prev) return state;
    return {...state, folders};
  },

  setProfiles(state, profiles) {
    const prev = state.profiles;
    if (typeof profiles === "function") profiles = profiles(prev);
    if (profiles === prev) return state;
    return {...state, profiles};
  },
}, {
  userId: 0,
  userName: null,
  userLevel: 0,
  folders: null,
  profiles: null,
}) {
  // nothing to see here
}
